import { useCallback } from "react";
import useApiClient from "../services/axiosInstance";

export const useSessionFeedbackService = () => {
  const { api } = useApiClient();

  const submitFeedback = useCallback(
    async (data) => {
      try {
        const response = await api.post("/api/feedback", data);
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    [api]
  );

  return { submitFeedback };
};
